var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCowface(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 13.80,20.20 Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 12.87,19.95 Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 11.18,19.83 Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 12.91,19.48 Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 12.84,19.48 Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 12.73,19.48 Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 12.59,19.48 L 12.66,19.48 Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 12.47,19.48 L 12.54,19.48 Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M 12.42,19.48 Z",
    fill: "currentColor"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M 11.84,19.48 L 12.38,19.48 Z",
    fill: "currentColor"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M 11.65,19.48 L 11.79,19.48 Z",
    fill: "currentColor"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M 11.53,19.48 Z",
    fill: "currentColor"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M 11.48,19.48 Z",
    fill: "currentColor"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M 11.16,19.48 L 11.34,19.48 Z",
    fill: "currentColor"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M 11.06,19.48 Z",
    fill: "currentColor"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M 12.98,19.45 L 13.05,19.45 Z",
    fill: "currentColor"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M 10.97,19.45 L 10.99,19.45 Z",
    fill: "currentColor"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M 10.92,19.45 Z",
    fill: "currentColor"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M 13.12,19.43 L 13.15,19.43 Z",
    fill: "currentColor"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M 10.80,19.43 L 10.83,19.43 Z",
    fill: "currentColor"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M 10.73,19.41 L 10.76,19.41 Z",
    fill: "currentColor"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M 13.29,19.38 L 13.27,19.41 L 13.22,19.41 L 13.29,19.41 L 13.31,19.38 L 13.34,19.38 Z",
    fill: "currentColor"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M 10.66,19.38 L 10.66,19.43 L 10.69,19.43 L 10.66,19.41 Z",
    fill: "currentColor"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M 15.05,19.36 Z",
    fill: "currentColor"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M 13.38,19.36 Z",
    fill: "currentColor"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M 10.62,19.36 Z",
    fill: "currentColor"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M 13.48,19.31 Z",
    fill: "currentColor"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M 10.50,19.31 Z",
    fill: "currentColor"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M 13.52,19.29 Z",
    fill: "currentColor"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M 10.41,19.27 L 10.43,19.29 L 10.45,19.29 L 10.43,19.29 Z",
    fill: "currentColor"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M 10.36,19.24 Z",
    fill: "currentColor"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M 13.66,19.22 Z",
    fill: "currentColor"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M 10.31,19.22 Z",
    fill: "currentColor"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M 13.73,19.17 Z",
    fill: "currentColor"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M 10.24,19.17 Z",
    fill: "currentColor"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M 13.85,19.15 Z",
    fill: "currentColor"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M 10.17,19.12 Z",
    fill: "currentColor"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M 13.99,19.10 Z",
    fill: "currentColor"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M 8.44,19.05 Z",
    fill: "currentColor"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M 13.97,18.98 L 13.97,19.01 Z",
    fill: "currentColor"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M 10.01,18.98 Z",
    fill: "currentColor"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M 14.02,18.94 Z",
    fill: "currentColor"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M 9.84,18.91 Z",
    fill: "currentColor"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M 14.23,18.84 Z",
    fill: "currentColor"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M 9.87,18.84 L 9.89,18.87 Z",
    fill: "currentColor"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M 14.13,18.82 Z",
    fill: "currentColor"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M 14.18,18.75 Z",
    fill: "currentColor"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M 9.77,18.75 Z",
    fill: "currentColor"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M 14.27,18.63 L 14.25,18.66 Z",
    fill: "currentColor"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M 9.68,18.59 Z",
    fill: "currentColor"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M 9.66,18.54 Z",
    fill: "currentColor"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M 9.61,18.45 L 9.61,18.47 Z",
    fill: "currentColor"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M 7.85,18.40 Z",
    fill: "currentColor"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M 14.93,18.33 Z",
    fill: "currentColor"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M 14.44,18.30 L 14.44,18.33 Z",
    fill: "currentColor"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M 14.53,18.19 L 14.51,18.21 L 14.48,18.21 L 14.46,18.23 L 14.46,18.26 L 14.46,18.23 L 14.48,18.21 L 14.51,18.21 Z",
    fill: "currentColor"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M 9.42,18.19 Z",
    fill: "currentColor"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M 9.35,18.16 Z",
    fill: "currentColor"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M 14.65,18.14 Z",
    fill: "currentColor"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M 9.23,18.09 L 9.26,18.12 L 9.28,18.12 L 9.26,18.12 Z",
    fill: "currentColor"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M 14.91,18.00 Z",
    fill: "currentColor"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M 9.07,18.00 Z",
    fill: "currentColor"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M 8.98,17.95 L 8.95,17.98 Z",
    fill: "currentColor"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M 8.86,17.91 L 8.91,17.95 Z",
    fill: "currentColor"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M 15.33,17.70 Z",
    fill: "currentColor"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M 8.58,17.60 L 8.62,17.65 L 8.62,17.67 L 8.62,17.65 Z",
    fill: "currentColor"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M 8.46,17.46 Z",
    fill: "currentColor"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M 8.39,17.39 Z",
    fill: "currentColor"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M 15.63,17.34 Z",
    fill: "currentColor"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M 7.43,17.32 Z",
    fill: "currentColor"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M 8.32,17.27 L 8.34,17.30 Z",
    fill: "currentColor"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M 15.75,17.13 Z",
    fill: "currentColor"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M 15.77,17.09 Z",
    fill: "currentColor"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M 8.20,17.06 Z",
    fill: "currentColor"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M 15.84,17.04 Z",
    fill: "currentColor"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M 8.18,17.02 Z",
    fill: "currentColor"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M 8.16,16.97 Z",
    fill: "currentColor"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M 15.84,16.95 L 15.84,16.97 L 15.82,16.99 L 15.84,16.97 Z",
    fill: "currentColor"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M 8.13,16.92 Z",
    fill: "currentColor"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M 15.87,16.88 L 15.87,16.90 Z",
    fill: "currentColor"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M 15.94,16.71 Z",
    fill: "currentColor"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M 15.96,16.62 Z",
    fill: "currentColor"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M 8.04,16.62 L 8.04,16.66 Z",
    fill: "currentColor"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M 8.02,16.52 L 8.02,16.57 Z",
    fill: "currentColor"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M 15.98,16.50 L 15.98,16.55 Z",
    fill: "currentColor"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M 7.99,16.43 L 7.99,16.48 Z",
    fill: "currentColor"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M 16.01,16.41 L 16.01,16.43 Z",
    fill: "currentColor"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M 7.97,16.24 L 7.97,16.34 Z",
    fill: "currentColor"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M 16.03,16.20 L 16.03,16.31 Z",
    fill: "currentColor"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M 7.95,16.17 Z",
    fill: "currentColor"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M 7.95,15.98 L 7.95,16.10 Z",
    fill: "currentColor"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M 16.05,15.94 Z",
    fill: "currentColor"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M 7.95,15.94 Z",
    fill: "currentColor"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M 16.03,15.73 L 16.03,15.82 Z",
    fill: "currentColor"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M 7.97,15.70 L 7.97,15.82 Z",
    fill: "currentColor"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M 16.01,15.61 Z",
    fill: "currentColor"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M 7.99,15.56 L 7.99,15.61 Z",
    fill: "currentColor"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M 8.02,15.49 L 8.02,15.52 Z",
    fill: "currentColor"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M 15.98,15.47 Z",
    fill: "currentColor"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M 8.04,15.40 L 8.04,15.42 Z",
    fill: "currentColor"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M 15.94,15.19 L 15.94,15.35 L 15.96,15.38 L 15.96,15.42 L 15.96,15.38 L 15.94,15.35 Z",
    fill: "currentColor"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M 8.06,15.19 L 8.06,15.33 Z",
    fill: "currentColor"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M 8.04,15.09 L 8.04,15.12 Z",
    fill: "currentColor"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M 15.96,14.93 L 15.96,15.12 Z",
    fill: "currentColor"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M 8.02,14.88 L 8.04,14.91 L 8.04,15.05 L 8.04,14.91 Z",
    fill: "currentColor"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M 7.62,14.77 Z",
    fill: "currentColor"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M 15.98,14.74 L 15.98,14.77 Z",
    fill: "currentColor"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M 7.64,14.67 Z",
    fill: "currentColor"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M 7.99,14.65 L 8.02,14.67 L 8.02,14.81 L 8.02,14.67 Z",
    fill: "currentColor"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M 16.01,14.46 L 16.01,14.53 Z",
    fill: "currentColor"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M 7.99,14.41 L 7.99,14.53 Z",
    fill: "currentColor"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M 16.01,14.39 L 16.01,14.41 Z",
    fill: "currentColor"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M 16.03,14.32 Z",
    fill: "currentColor"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M 16.03,14.13 L 16.03,14.25 Z",
    fill: "currentColor"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M 7.97,14.11 L 7.97,14.34 Z",
    fill: "currentColor"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M 16.03,14.09 Z",
    fill: "currentColor"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M 7.95,13.90 L 7.95,14.02 Z",
    fill: "currentColor"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M 16.05,13.83 L 16.05,13.85 L 16.08,13.88 L 16.05,13.90 L 16.05,13.97 L 16.05,13.90 L 16.08,13.88 L 16.05,13.85 Z",
    fill: "currentColor"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M 16.08,13.73 Z",
    fill: "currentColor"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M 7.92,13.73 L 7.92,13.80 Z",
    fill: "currentColor"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M 7.92,13.62 L 7.92,13.69 Z",
    fill: "currentColor"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M 16.08,13.57 L 16.08,13.69 Z",
    fill: "currentColor"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M 7.90,13.57 Z",
    fill: "currentColor"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M 7.90,13.38 L 7.90,13.52 Z",
    fill: "currentColor"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M 16.10,13.34 L 16.10,13.43 Z",
    fill: "currentColor"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M 7.88,13.12 L 7.88,13.22 Z",
    fill: "currentColor"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M 16.12,13.05 L 16.12,13.20 Z",
    fill: "currentColor"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M 7.85,13.03 Z",
    fill: "currentColor"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M 6.77,12.94 Z",
    fill: "currentColor"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M 7.85,12.82 L 7.85,12.94 Z",
    fill: "currentColor"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M 16.15,12.77 L 16.15,12.96 Z",
    fill: "currentColor"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M 7.83,12.54 L 7.83,12.73 Z",
    fill: "currentColor"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M 16.17,12.49 L 16.17,12.68 Z",
    fill: "currentColor"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M 16.20,12.45 Z",
    fill: "currentColor"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M 7.80,12.28 L 7.80,12.45 Z",
    fill: "currentColor"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M 16.24,12.26 Z",
    fill: "currentColor"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M 16.20,12.23 L 16.20,12.40 Z",
    fill: "currentColor"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M 16.22,12.14 L 16.22,12.16 Z",
    fill: "currentColor"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M 7.78,12.02 L 7.78,12.21 Z",
    fill: "currentColor"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M 16.22,11.98 L 16.22,12.09 Z",
    fill: "currentColor"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M 7.69,11.91 Z",
    fill: "currentColor"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M 16.24,11.77 L 16.24,11.88 Z",
    fill: "currentColor"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M 7.76,11.74 L 7.76,11.91 Z",
    fill: "currentColor"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M 18.05,11.53 Z",
    fill: "currentColor"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M 17.88,11.53 L 17.98,11.53 Z",
    fill: "currentColor"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M 17.84,11.53 Z",
    fill: "currentColor"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M 17.77,11.53 Z",
    fill: "currentColor"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M 16.27,11.53 Z",
    fill: "currentColor"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M 6.26,11.53 Z",
    fill: "currentColor"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M 6.00,11.53 L 6.19,11.53 Z",
    fill: "currentColor"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M 5.91,11.53 Z",
    fill: "currentColor"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M 18.12,11.51 L 18.26,11.51 Z",
    fill: "currentColor"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M 7.73,11.51 L 7.73,11.70 L 7.71,11.72 L 7.69,11.72 L 7.71,11.72 L 7.73,11.70 Z",
    fill: "currentColor"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M 6.35,11.51 L 6.45,11.51 Z",
    fill: "currentColor"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M 5.74,11.51 L 5.81,11.51 Z",
    fill: "currentColor"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M 18.30,11.48 L 18.38,11.48 Z",
    fill: "currentColor"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M 16.27,11.48 Z",
    fill: "currentColor"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M 6.52,11.48 L 6.61,11.48 Z",
    fill: "currentColor"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M 5.62,11.48 L 5.70,11.48 Z",
    fill: "currentColor"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M 18.45,11.46 L 18.47,11.46 Z",
    fill: "currentColor"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M 17.27,11.46 L 17.34,11.46 L 17.37,11.48 L 17.44,11.48 L 17.46,11.51 L 17.48,11.48 L 17.51,11.51 L 17.60,11.51 L 17.62,11.53 L 17.62,11.51 L 17.51,11.51 L 17.48,11.48 L 17.37,11.48 L 17.34,11.46 Z",
    fill: "currentColor"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M 6.68,11.46 L 6.70,11.46 Z",
    fill: "currentColor"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M 5.53,11.46 L 5.55,11.46 L 5.58,11.48 L 5.58,11.46 Z",
    fill: "currentColor"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M 18.61,11.41 L 18.59,11.44 L 18.54,11.44 L 18.59,11.44 Z",
    fill: "currentColor"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M 17.13,11.41 L 17.16,11.41 L 17.18,11.44 L 17.23,11.44 L 17.18,11.44 L 17.16,11.41 Z",
    fill: "currentColor"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M 18.68,11.39 Z",
    fill: "currentColor"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M 17.09,11.39 Z",
    fill: "currentColor"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M 7.71,11.39 Z",
    fill: "currentColor"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M 5.32,11.39 L 5.34,11.41 L 5.39,11.41 L 5.41,11.44 L 5.48,11.44 L 5.41,11.44 L 5.39,11.41 L 5.34,11.41 Z",
    fill: "currentColor"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M 18.75,11.37 Z",
    fill: "currentColor"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M 16.99,11.37 L 17.02,11.37 Z",
    fill: "currentColor"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M 7.01,11.37 Z",
    fill: "currentColor"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M 18.80,11.34 Z",
    fill: "currentColor"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M 5.23,11.34 L 5.25,11.37 Z",
    fill: "currentColor"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M 16.88,11.32 L 16.90,11.32 L 16.92,11.34 L 16.95,11.34 L 16.92,11.34 L 16.90,11.32 Z",
    fill: "currentColor"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M 5.16,11.32 Z",
    fill: "currentColor"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M 7.15,11.30 L 7.10,11.34 L 7.08,11.34 L 7.10,11.34 L 7.15,11.30 L 7.17,11.30 Z",
    fill: "currentColor"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M 5.11,11.30 Z",
    fill: "currentColor"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M 18.94,11.27 Z",
    fill: "currentColor"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M 16.76,11.27 L 16.78,11.27 L 16.80,11.30 L 16.83,11.30 L 16.80,11.30 L 16.78,11.27 Z",
    fill: "currentColor"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M 5.06,11.27 Z",
    fill: "currentColor"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M 18.98,11.25 Z",
    fill: "currentColor"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M 16.29,11.25 L 16.29,11.30 Z",
    fill: "currentColor"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M 7.71,11.25 L 7.71,11.34 Z",
    fill: "currentColor"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M 19.15,11.20 Z",
    fill: "currentColor"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M 16.29,11.20 Z",
    fill: "currentColor"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M 7.38,11.18 Z",
    fill: "currentColor"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M 19.12,11.16 Z",
    fill: "currentColor"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M 7.45,11.13 Z",
    fill: "currentColor"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M 16.45,11.09 Z",
    fill: "currentColor"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M 4.76,11.09 L 4.80,11.13 L 4.83,11.13 L 4.88,11.18 L 4.83,11.13 L 4.80,11.13 Z",
    fill: "currentColor"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M 16.31,11.06 L 16.31,11.11 Z",
    fill: "currentColor"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M 7.57,11.06 Z",
    fill: "currentColor"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M 4.62,11.04 Z",
    fill: "currentColor"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M 19.45,10.97 L 19.48,10.97 Z",
    fill: "currentColor"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M 7.69,10.97 L 7.66,10.99 L 7.69,11.02 L 7.69,11.20 Z",
    fill: "currentColor"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M 19.50,10.88 Z",
    fill: "currentColor"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M 19.99,10.34 Z",
    fill: "currentColor"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M 4.01,10.34 L 4.01,10.36 L 4.03,10.38 L 4.01,10.36 Z",
    fill: "currentColor"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M 19.99,10.29 Z",
    fill: "currentColor"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M 3.98,10.29 Z",
    fill: "currentColor"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M 20.02,10.17 L 20.02,10.24 Z",
    fill: "currentColor"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M 3.96,10.12 Z",
    fill: "currentColor"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M 20.02,10.05 L 20.02,10.08 Z",
    fill: "currentColor"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M 19.99,10.01 Z",
    fill: "currentColor"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M 19.97,9.94 Z",
    fill: "currentColor"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M 4.05,9.87 Z",
    fill: "currentColor"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M 4.24,9.66 L 4.22,9.68 Z",
    fill: "currentColor"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M 19.52,9.49 Z",
    fill: "currentColor"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M 4.45,9.49 L 4.43,9.52 Z",
    fill: "currentColor"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M 19.31,9.35 Z",
    fill: "currentColor"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M 19.20,9.28 Z",
    fill: "currentColor"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M 19.15,9.26 Z",
    fill: "currentColor"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M 4.80,9.26 L 4.78,9.28 L 4.80,9.26 L 4.83,9.26 Z",
    fill: "currentColor"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M 19.01,9.19 Z",
    fill: "currentColor"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M 4.95,9.19 Z",
    fill: "currentColor"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M 18.91,9.14 Z",
    fill: "currentColor"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M 18.87,9.12 Z",
    fill: "currentColor"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M 18.82,9.09 Z",
    fill: "currentColor"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M 5.16,9.09 L 5.18,9.09 Z",
    fill: "currentColor"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M 18.73,9.07 L 18.75,9.07 Z",
    fill: "currentColor"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M 5.25,9.07 L 5.27,9.07 Z",
    fill: "currentColor"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M 18.61,9.05 L 18.68,9.05 Z",
    fill: "currentColor"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M 5.32,9.05 L 5.34,9.05 Z",
    fill: "currentColor"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M 18.54,9.02 Z",
    fill: "currentColor"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M 5.44,9.02 Z",
    fill: "currentColor"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M 18.42,9.00 L 18.45,9.00 Z",
    fill: "currentColor"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M 5.53,9.00 L 5.55,9.00 Z",
    fill: "currentColor"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M 18.23,8.98 L 18.35,8.98 Z",
    fill: "currentColor"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M 5.62,8.98 L 5.74,8.98 Z",
    fill: "currentColor"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M 17.79,8.93 L 17.77,8.95 L 17.72,8.95 L 18.16,8.95 L 17.81,8.95 Z",
    fill: "currentColor"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M 6.21,8.84 Z",
    fill: "currentColor"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M 6.14,8.74 Z",
    fill: "currentColor"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M 6.09,8.67 L 6.12,8.70 Z",
    fill: "currentColor"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M 18.02,8.48 Z",
    fill: "currentColor"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M 5.95,8.41 L 5.98,8.44 Z",
    fill: "currentColor"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M 18.09,8.32 L 18.09,8.34 L 18.07,8.37 L 18.09,8.34 Z",
    fill: "currentColor"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M 5.91,8.30 L 5.91,8.32 L 5.93,8.34 L 5.91,8.32 Z",
    fill: "currentColor"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M 5.88,8.25 Z",
    fill: "currentColor"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M 18.14,8.20 Z",
    fill: "currentColor"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M 5.84,8.13 Z",
    fill: "currentColor"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M 18.19,8.11 Z",
    fill: "currentColor"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M 5.81,8.06 Z",
    fill: "currentColor"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M 18.21,8.02 Z",
    fill: "currentColor"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M 5.79,7.99 L 5.79,8.02 Z",
    fill: "currentColor"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M 18.23,7.92 L 18.23,7.95 Z",
    fill: "currentColor"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M 5.77,7.92 Z",
    fill: "currentColor"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M 18.26,7.85 Z",
    fill: "currentColor"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M 5.74,7.83 Z",
    fill: "currentColor"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M 18.28,7.76 L 18.28,7.80 Z",
    fill: "currentColor"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M 5.72,7.76 Z",
    fill: "currentColor"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M 18.30,7.66 L 18.30,7.69 Z",
    fill: "currentColor"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M 5.70,7.64 Z",
    fill: "currentColor"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M 8.95,7.59 Z",
    fill: "currentColor"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M 5.67,7.59 Z",
    fill: "currentColor"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M 14.88,7.57 Z",
    fill: "currentColor"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M 18.33,7.55 Z",
    fill: "currentColor"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M 14.84,7.55 Z",
    fill: "currentColor"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M 9.16,7.55 Z",
    fill: "currentColor"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M 5.67,7.52 L 5.67,7.55 Z",
    fill: "currentColor"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M 9.26,7.50 Z",
    fill: "currentColor"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M 9.21,7.50 Z",
    fill: "currentColor"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M 9.07,7.50 Z",
    fill: "currentColor"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M 15.23,7.45 Z",
    fill: "currentColor"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M 14.67,7.45 Z",
    fill: "currentColor"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M 9.35,7.45 Z",
    fill: "currentColor"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M 18.35,7.43 Z",
    fill: "currentColor"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M 14.62,7.43 Z",
    fill: "currentColor"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M 14.55,7.41 L 14.58,7.41 Z",
    fill: "currentColor"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M 9.45,7.41 Z",
    fill: "currentColor"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M 9.38,7.41 Z",
    fill: "currentColor"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M 8.70,7.41 Z",
    fill: "currentColor"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M 15.28,7.38 Z",
    fill: "currentColor"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M 14.48,7.38 L 14.51,7.38 Z",
    fill: "currentColor"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M 9.52,7.38 Z",
    fill: "currentColor"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M 5.65,7.38 L 5.65,7.41 Z",
    fill: "currentColor"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M 14.37,7.34 Z",
    fill: "currentColor"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M 9.59,7.34 L 9.56,7.36 Z",
    fill: "currentColor"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M 14.30,7.31 Z",
    fill: "currentColor"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M 9.68,7.31 Z",
    fill: "currentColor"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M 15.45,7.29 Z",
    fill: "currentColor"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M 14.25,7.29 Z",
    fill: "currentColor"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M 9.75,7.29 L 9.73,7.31 L 9.75,7.29 L 9.80,7.29 Z",
    fill: "currentColor"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M 14.16,7.27 L 14.18,7.27 L 14.20,7.29 L 14.18,7.27 Z",
    fill: "currentColor"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M 9.84,7.27 L 9.87,7.27 Z",
    fill: "currentColor"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M 8.53,7.27 Z",
    fill: "currentColor"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M 15.45,7.24 Z",
    fill: "currentColor"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M 9.94,7.24 L 9.98,7.24 Z",
    fill: "currentColor"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M 5.62,7.24 Z",
    fill: "currentColor"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M 13.90,7.22 L 13.99,7.22 L 14.02,7.24 L 14.11,7.24 L 14.02,7.24 L 13.99,7.22 Z",
    fill: "currentColor"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M 10.03,7.22 L 10.08,7.22 Z",
    fill: "currentColor"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M 8.48,7.22 Z",
    fill: "currentColor"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M 15.54,7.20 Z",
    fill: "currentColor"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M 13.73,7.20 L 13.78,7.20 Z",
    fill: "currentColor"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M 10.17,7.20 L 10.24,7.20 Z",
    fill: "currentColor"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M 13.59,7.17 Z",
    fill: "currentColor"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M 10.36,7.17 L 13.52,7.17 Z",
    fill: "currentColor"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M 5.62,7.17 L 5.62,7.20 Z",
    fill: "currentColor"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M 18.38,7.15 L 18.38,7.29 Z",
    fill: "currentColor"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M 8.58,7.12 Z",
    fill: "currentColor"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M 18.40,7.08 Z",
    fill: "currentColor"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M 15.66,7.08 L 15.61,7.12 Z",
    fill: "currentColor"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M 8.32,7.05 L 8.39,7.12 Z",
    fill: "currentColor"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M 8.23,6.94 Z",
    fill: "currentColor"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M 5.60,6.91 L 5.60,6.94 Z",
    fill: "currentColor"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M 8.18,6.89 Z",
    fill: "currentColor"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M 8.13,6.82 Z",
    fill: "currentColor"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M 5.60,6.82 L 5.60,6.87 Z",
    fill: "currentColor"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M 8.16,6.77 Z",
    fill: "currentColor"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M 5.60,6.75 Z",
    fill: "currentColor"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M 18.40,6.73 L 18.40,7.03 Z",
    fill: "currentColor"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M 15.98,6.63 Z",
    fill: "currentColor"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M 16.03,6.54 Z",
    fill: "currentColor"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M 5.62,6.52 L 5.62,6.61 Z",
    fill: "currentColor"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M 16.05,6.49 Z",
    fill: "currentColor"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M 18.38,6.47 L 18.38,6.59 Z",
    fill: "currentColor"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M 18.35,6.38 Z",
    fill: "currentColor"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M 5.65,6.35 L 5.65,6.40 Z",
    fill: "currentColor"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M 16.15,6.30 Z",
    fill: "currentColor"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M 7.85,6.30 Z",
    fill: "currentColor"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M 18.33,6.26 Z",
    fill: "currentColor"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M 7.83,6.26 Z",
    fill: "currentColor"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M 16.17,6.23 Z",
    fill: "currentColor"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M 5.67,6.21 L 5.67,6.26 Z",
    fill: "currentColor"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M 16.20,6.16 Z",
    fill: "currentColor"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M 7.78,6.14 L 7.80,6.16 L 7.80,6.14 Z",
    fill: "currentColor"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M 5.70,6.14 L 5.70,6.16 Z",
    fill: "currentColor"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M 18.30,6.12 L 18.30,6.16 Z",
    fill: "currentColor"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M 7.78,6.09 Z",
    fill: "currentColor"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M 18.28,6.05 L 18.28,6.07 Z",
    fill: "currentColor"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M 5.72,6.05 L 5.72,6.07 Z",
    fill: "currentColor"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M 16.24,6.02 L 16.24,6.05 L 16.22,6.07 L 16.22,6.09 L 16.22,6.07 L 16.24,6.05 Z",
    fill: "currentColor"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M 7.76,6.02 L 7.76,6.05 L 7.78,6.02 L 7.80,6.02 Z",
    fill: "currentColor"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M 18.26,5.98 Z",
    fill: "currentColor"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M 16.27,5.95 Z",
    fill: "currentColor"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M 5.74,5.93 L 5.74,5.98 Z",
    fill: "currentColor"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M 18.23,5.88 Z",
    fill: "currentColor"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M 16.29,5.86 L 16.29,5.88 Z",
    fill: "currentColor"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M 7.71,5.86 L 7.71,5.91 Z",
    fill: "currentColor"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M 5.77,5.86 Z",
    fill: "currentColor"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M 5.79,5.81 Z",
    fill: "currentColor"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M 18.19,5.74 L 18.19,5.77 Z",
    fill: "currentColor"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M 16.31,5.74 L 16.31,5.79 Z",
    fill: "currentColor"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M 7.69,5.74 L 7.69,5.79 Z",
    fill: "currentColor"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M 5.81,5.74 Z",
    fill: "currentColor"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M 5.84,5.70 Z",
    fill: "currentColor"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M 18.14,5.62 Z",
    fill: "currentColor"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M 16.34,5.62 Z",
    fill: "currentColor"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M 7.66,5.62 L 7.66,5.67 Z",
    fill: "currentColor"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M 5.86,5.62 Z",
    fill: "currentColor"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M 18.12,5.58 Z",
    fill: "currentColor"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M 18.09,5.51 L 18.09,5.53 Z",
    fill: "currentColor"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M 5.91,5.51 Z",
    fill: "currentColor"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M 7.64,5.48 L 7.64,5.53 Z",
    fill: "currentColor"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M 18.07,5.46 Z",
    fill: "currentColor"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M 16.36,5.46 L 16.36,5.53 Z",
    fill: "currentColor"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M 16.36,5.39 L 16.36,5.41 Z",
    fill: "currentColor"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M 7.64,5.37 L 7.64,5.41 Z",
    fill: "currentColor"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M 14.65,5.25 Z",
    fill: "currentColor"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M 16.38,5.23 Z",
    fill: "currentColor"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M 17.93,5.20 Z",
    fill: "currentColor"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M 6.07,5.20 L 6.05,5.23 L 6.05,5.25 L 6.02,5.27 L 6.05,5.25 L 6.05,5.23 Z",
    fill: "currentColor"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M 6.12,5.13 Z",
    fill: "currentColor"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M 7.62,5.06 L 7.62,5.13 L 7.64,5.11 L 7.62,5.09 Z",
    fill: "currentColor"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M 7.62,4.99 L 7.62,5.02 Z",
    fill: "currentColor"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M 17.72,4.90 L 17.74,4.92 Z",
    fill: "currentColor"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M 16.38,4.90 L 16.38,5.13 Z",
    fill: "currentColor"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M 7.62,4.88 L 7.62,4.95 Z",
    fill: "currentColor"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M 16.38,4.85 Z",
    fill: "currentColor"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M 16.41,4.80 Z",
    fill: "currentColor"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M 7.59,4.80 L 7.59,4.83 Z",
    fill: "currentColor"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M 6.35,4.80 Z",
    fill: "currentColor"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M 7.57,4.76 Z",
    fill: "currentColor"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M 17.53,4.66 Z",
    fill: "currentColor"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M 17.51,4.62 Z",
    fill: "currentColor"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M 7.50,4.62 Z",
    fill: "currentColor"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M 16.52,4.59 Z",
    fill: "currentColor"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M 7.36,4.48 Z",
    fill: "currentColor"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M 6.70,4.48 Z",
    fill: "currentColor"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M 16.69,4.45 Z",
    fill: "currentColor"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M 7.31,4.45 Z",
    fill: "currentColor"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M 16.73,4.43 Z",
    fill: "currentColor"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M 7.27,4.43 Z",
    fill: "currentColor"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M 17.18,4.41 L 17.20,4.43 L 17.18,4.45 L 17.13,4.45 L 17.11,4.43 L 16.85,4.43 L 16.83,4.45 L 16.78,4.45 L 16.76,4.48 L 16.73,4.48 L 16.71,4.50 L 16.69,4.50 L 16.62,4.57 L 16.59,4.57 L 16.57,4.59 L 16.57,4.62 L 16.52,4.66 L 16.52,4.69 L 16.48,4.73 L 16.48,4.78 L 16.45,4.80 L 16.45,4.85 L 16.43,4.88 L 16.43,5.37 L 16.41,5.39 L 16.41,5.58 L 16.38,5.60 L 16.38,5.72 L 16.36,5.74 L 16.36,5.84 L 16.34,5.86 L 16.34,5.93 L 16.31,5.95 L 16.31,6.00 L 16.29,6.02 L 16.29,6.09 L 16.27,6.12 L 16.27,6.14 L 16.24,6.16 L 16.24,6.21 L 16.22,6.23 L 16.22,6.28 L 16.20,6.30 L 16.20,6.33 L 16.17,6.35 L 16.17,6.38 L 16.15,6.40 L 16.15,6.42 L 16.12,6.45 L 16.12,6.47 L 16.10,6.49 L 16.10,6.52 L 16.08,6.54 L 16.08,6.56 L 16.05,6.59 L 16.05,6.61 L 16.03,6.63 L 16.03,6.66 L 15.98,6.70 L 15.98,6.73 L 15.94,6.77 L 15.94,6.80 L 15.89,6.84 L 15.87,6.82 L 15.82,6.87 L 15.87,6.82 L 15.89,6.84 L 15.89,6.87 L 15.82,6.94 L 15.80,6.91 L 15.77,6.94 L 15.80,6.91 L 15.82,6.94 L 15.82,6.96 L 15.70,7.08 L 15.70,7.10 L 15.47,7.34 L 15.45,7.34 L 15.30,7.48 L 15.28,7.48 L 15.23,7.52 L 15.21,7.52 L 15.14,7.59 L 15.12,7.59 L 15.07,7.64 L 15.05,7.64 L 15.00,7.69 L 14.98,7.69 L 14.93,7.64 L 14.95,7.62 L 14.93,7.64 L 14.91,7.64 L 14.88,7.62 L 14.86,7.62 L 14.84,7.59 L 14.81,7.59 L 14.77,7.55 L 14.79,7.52 L 14.77,7.50 L 14.74,7.50 L 14.72,7.48 L 14.74,7.50 L 14.72,7.52 L 14.70,7.52 L 14.67,7.50 L 14.65,7.50 L 14.62,7.48 L 14.58,7.48 L 14.55,7.45 L 14.53,7.45 L 14.51,7.43 L 14.46,7.43 L 14.44,7.41 L 14.41,7.41 L 14.39,7.38 L 14.34,7.38 L 14.32,7.36 L 14.27,7.36 L 14.25,7.34 L 14.18,7.34 L 14.16,7.31 L 14.11,7.31 L 14.09,7.29 L 13.99,7.29 L 13.97,7.27 L 13.85,7.27 L 13.83,7.24 L 13.64,7.24 L 13.62,7.22 L 10.38,7.22 L 10.36,7.24 L 10.34,7.22 L 10.31,7.24 L 10.17,7.24 L 10.15,7.27 L 10.05,7.27 L 10.03,7.29 L 9.94,7.29 L 9.91,7.31 L 9.84,7.31 L 9.82,7.34 L 9.77,7.34 L 9.75,7.36 L 9.70,7.36 L 9.68,7.38 L 9.63,7.38 L 9.61,7.41 L 9.56,7.41 L 9.54,7.43 L 9.49,7.43 L 9.47,7.45 L 9.45,7.45 L 9.42,7.48 L 9.40,7.48 L 9.38,7.50 L 9.33,7.50 L 9.30,7.48 L 9.33,7.50 L 9.28,7.55 L 9.26,7.55 L 9.23,7.57 L 9.21,7.57 L 9.19,7.59 L 9.16,7.59 L 9.14,7.62 L 9.12,7.62 L 9.09,7.64 L 9.07,7.64 L 9.02,7.69 L 9.00,7.69 L 8.98,7.66 L 8.95,7.66 L 8.91,7.62 L 8.88,7.62 L 8.81,7.55 L 8.79,7.55 L 8.72,7.48 L 8.74,7.45 L 8.72,7.48 L 8.70,7.48 L 8.62,7.41 L 8.60,7.41 L 8.25,7.05 L 8.25,7.03 L 8.13,6.91 L 8.13,6.89 L 8.09,6.84 L 8.09,6.82 L 8.04,6.77 L 8.04,6.75 L 8.06,6.73 L 8.06,6.70 L 8.06,6.73 L 8.04,6.75 L 7.99,6.70 L 7.99,6.68 L 7.97,6.66 L 7.97,6.63 L 7.92,6.59 L 7.92,6.56 L 7.90,6.54 L 7.90,6.52 L 7.88,6.49 L 7.88,6.47 L 7.85,6.45 L 7.85,6.42 L 7.83,6.40 L 7.83,6.35 L 7.80,6.33 L 7.80,6.30 L 7.78,6.28 L 7.78,6.26 L 7.76,6.23 L 7.76,6.19 L 7.73,6.16 L 7.73,6.12 L 7.71,6.09 L 7.71,6.05 L 7.69,6.02 L 7.69,5.95 L 7.66,5.93 L 7.66,5.86 L 7.64,5.84 L 7.64,5.77 L 7.62,5.74 L 7.62,5.62 L 7.59,5.60 L 7.59,5.39 L 7.57,5.37 L 7.57,4.90 L 7.55,4.88 L 7.55,4.80 L 7.52,4.78 L 7.52,4.76 L 7.50,4.73 L 7.50,4.71 L 7.48,4.69 L 7.48,4.66 L 7.31,4.50 L 7.29,4.50 L 7.27,4.48 L 7.24,4.48 L 7.22,4.45 L 7.17,4.45 L 7.15,4.43 L 6.94,4.43 L 6.91,4.45 L 6.84,4.45 L 6.82,4.48 L 6.80,4.48 L 6.77,4.50 L 6.75,4.50 L 6.73,4.52 L 6.70,4.52 L 6.61,4.62 L 6.59,4.62 L 6.45,4.76 L 6.45,4.78 L 6.33,4.90 L 6.33,4.92 L 6.26,4.99 L 6.26,5.02 L 6.21,5.06 L 6.21,5.09 L 6.16,5.13 L 6.16,5.16 L 6.12,5.20 L 6.12,5.23 L 6.09,5.25 L 6.09,5.27 L 6.07,5.30 L 6.07,5.32 L 6.02,5.37 L 6.00,5.34 L 6.00,5.32 L 6.00,5.34 L 6.02,5.37 L 6.02,5.39 L 6.00,5.41 L 6.00,5.44 L 5.98,5.46 L 5.98,5.48 L 5.95,5.51 L 5.95,5.55 L 5.93,5.58 L 5.93,5.60 L 5.91,5.62 L 5.91,5.65 L 5.88,5.67 L 5.88,5.72 L 5.86,5.74 L 5.86,5.77 L 5.84,5.79 L 5.84,5.84 L 5.81,5.86 L 5.81,5.93 L 5.79,5.95 L 5.79,6.00 L 5.77,6.02 L 5.77,6.09 L 5.74,6.12 L 5.74,6.19 L 5.72,6.21 L 5.72,6.30 L 5.70,6.33 L 5.70,6.47 L 5.67,6.49 L 5.67,6.75 L 5.65,6.77 L 5.65,6.96 L 5.67,6.98 L 5.67,7.29 L 5.70,7.31 L 5.70,7.43 L 5.72,7.45 L 5.72,7.57 L 5.74,7.59 L 5.74,7.66 L 5.77,7.69 L 5.77,7.78 L 5.79,7.80 L 5.79,7.85 L 5.81,7.88 L 5.81,7.92 L 5.84,7.95 L 5.84,7.99 L 5.86,8.02 L 5.86,8.06 L 5.88,8.09 L 5.88,8.13 L 5.91,8.16 L 5.91,8.20 L 5.93,8.23 L 5.93,8.25 L 5.95,8.27 L 5.95,8.30 L 5.98,8.32 L 5.98,8.34 L 6.00,8.37 L 6.00,8.39 L 6.02,8.41 L 6.02,8.46 L 6.07,8.51 L 6.07,8.53 L 6.09,8.55 L 6.09,8.58 L 6.12,8.60 L 6.12,8.62 L 6.16,8.67 L 6.16,8.70 L 6.21,8.74 L 6.21,8.77 L 6.26,8.81 L 6.26,8.84 L 6.33,8.91 L 6.33,8.93 L 6.30,8.95 L 6.28,8.95 L 6.26,8.93 L 6.23,8.95 L 5.81,8.95 L 6.30,8.95 L 6.33,8.93 L 6.38,8.98 L 6.35,9.00 L 5.86,9.00 L 5.84,9.02 L 5.65,9.02 L 5.62,9.05 L 5.51,9.05 L 5.48,9.07 L 5.41,9.07 L 5.39,9.09 L 5.32,9.09 L 5.30,9.12 L 5.25,9.12 L 5.23,9.14 L 5.18,9.14 L 5.16,9.16 L 5.11,9.16 L 5.09,9.19 L 5.04,9.19 L 5.02,9.16 L 5.04,9.14 L 5.02,9.16 L 4.99,9.16 L 5.02,9.16 L 5.04,9.19 L 5.02,9.21 L 4.99,9.21 L 4.97,9.23 L 4.95,9.23 L 4.90,9.28 L 4.88,9.28 L 4.85,9.30 L 4.83,9.30 L 4.80,9.33 L 4.78,9.33 L 4.76,9.35 L 4.73,9.35 L 4.69,9.40 L 4.66,9.40 L 4.64,9.38 L 4.66,9.40 L 4.62,9.45 L 4.59,9.45 L 4.55,9.49 L 4.52,9.49 L 4.45,9.56 L 4.43,9.56 L 4.36,9.63 L 4.34,9.63 L 4.10,9.87 L 4.10,9.89 L 4.08,9.91 L 4.08,9.94 L 4.05,9.96 L 4.05,9.98 L 4.03,10.01 L 4.03,10.08 L 4.01,10.10 L 4.01,10.22 L 4.03,10.24 L 4.03,10.29 L 4.05,10.31 L 4.05,10.34 L 4.08,10.36 L 4.08,10.38 L 4.12,10.43 L 4.12,10.45 L 4.15,10.48 L 4.12,10.50 L 4.15,10.48 L 4.31,10.64 L 4.31,10.66 L 4.29,10.69 L 4.31,10.66 L 4.34,10.66 L 4.52,10.85 L 4.50,10.88 L 4.48,10.88 L 4.41,10.80 L 4.48,10.88 L 4.50,10.88 L 4.52,10.85 L 4.57,10.90 L 4.59,10.90 L 4.66,10.97 L 4.69,10.97 L 4.76,11.04 L 4.78,11.04 L 4.83,11.09 L 4.85,11.09 L 4.90,11.13 L 4.92,11.13 L 4.95,11.16 L 4.97,11.16 L 5.02,11.20 L 4.99,11.23 L 4.99,11.25 L 4.99,11.23 L 5.02,11.20 L 5.04,11.20 L 5.06,11.23 L 5.09,11.23 L 5.11,11.25 L 5.13,11.25 L 5.16,11.27 L 5.18,11.27 L 5.20,11.30 L 5.25,11.30 L 5.27,11.32 L 5.30,11.32 L 5.32,11.34 L 5.34,11.34 L 5.37,11.37 L 5.44,11.37 L 5.46,11.39 L 5.51,11.39 L 5.53,11.41 L 5.60,11.41 L 5.62,11.44 L 5.74,11.44 L 5.77,11.46 L 6.47,11.46 L 6.49,11.44 L 6.61,11.44 L 6.63,11.41 L 6.70,11.41 L 6.73,11.39 L 6.80,11.39 L 6.82,11.41 L 6.80,11.44 L 6.75,11.44 L 6.80,11.44 L 6.82,11.41 L 6.89,11.41 L 6.91,11.39 L 6.89,11.41 L 6.82,11.41 L 6.80,11.39 L 6.82,11.37 L 6.87,11.37 L 6.89,11.34 L 6.94,11.34 L 6.96,11.32 L 7.01,11.32 L 7.03,11.30 L 7.05,11.30 L 7.08,11.27 L 7.10,11.27 L 7.12,11.25 L 7.17,11.25 L 7.20,11.23 L 7.22,11.23 L 7.24,11.25 L 7.22,11.27 L 7.24,11.25 L 7.22,11.23 L 7.27,11.18 L 7.29,11.18 L 7.31,11.16 L 7.34,11.16 L 7.36,11.13 L 7.38,11.13 L 7.43,11.09 L 7.45,11.09 L 7.50,11.04 L 7.52,11.04 L 7.57,10.99 L 7.59,10.99 L 7.66,10.92 L 7.69,10.92 L 7.71,10.90 L 7.73,10.92 L 7.73,11.13 L 7.76,11.16 L 7.76,11.39 L 7.78,11.41 L 7.78,11.65 L 7.80,11.67 L 7.80,11.91 L 7.83,11.93 L 7.83,12.19 L 7.85,12.21 L 7.85,12.45 L 7.88,12.47 L 7.88,12.70 L 7.90,12.73 L 7.90,12.96 L 7.92,12.98 L 7.92,13.22 L 7.95,13.24 L 7.95,13.50 L 7.97,13.52 L 7.97,13.76 L 7.99,13.78 L 7.99,14.02 L 8.02,14.04 L 8.02,14.27 L 8.04,14.30 L 8.04,14.55 L 8.06,14.58 L 8.06,14.81 L 8.09,14.84 L 8.09,15.09 L 8.11,15.12 L 8.11,15.38 L 8.09,15.40 L 8.09,15.45 L 8.06,15.47 L 8.06,15.54 L 8.04,15.56 L 8.04,15.68 L 8.02,15.70 L 8.02,15.94 L 7.99,15.96 L 8.02,15.98 L 7.99,16.01 L 7.99,16.08 L 8.02,16.10 L 8.02,16.34 L 8.04,16.36 L 8.04,16.48 L 8.06,16.50 L 8.06,16.57 L 8.09,16.59 L 8.09,16.64 L 8.11,16.66 L 8.11,16.73 L 8.13,16.76 L 8.13,16.78 L 8.16,16.80 L 8.16,16.85 L 8.18,16.88 L 8.18,16.90 L 8.20,16.92 L 8.20,16.97 L 8.23,16.99 L 8.23,17.02 L 8.25,17.04 L 8.25,17.06 L 8.27,17.09 L 8.27,17.11 L 8.25,17.13 L 8.23,17.11 L 8.25,17.13 L 8.25,17.16 L 8.27,17.18 L 8.30,17.16 L 8.34,17.20 L 8.34,17.23 L 8.39,17.27 L 8.39,17.30 L 8.44,17.34 L 8.44,17.37 L 8.51,17.44 L 8.51,17.46 L 8.84,17.79 L 8.81,17.81 L 8.84,17.79 L 8.86,17.79 L 8.93,17.86 L 8.91,17.88 L 8.93,17.91 L 8.91,17.88 L 8.93,17.86 L 8.95,17.86 L 9.00,17.91 L 9.02,17.91 L 9.07,17.95 L 9.09,17.95 L 9.14,18.00 L 9.16,18.00 L 9.19,18.02 L 9.21,18.02 L 9.23,18.05 L 9.26,18.05 L 9.28,18.07 L 9.30,18.07 L 9.33,18.09 L 9.35,18.09 L 9.38,18.12 L 9.40,18.12 L 9.42,18.14 L 9.47,18.14 L 9.49,18.16 L 9.52,18.16 L 9.54,18.19 L 9.52,18.21 L 9.47,18.21 L 9.49,18.21 L 9.54,18.26 L 9.54,18.33 L 9.56,18.35 L 9.56,18.33 L 9.54,18.30 L 9.54,18.26 L 9.52,18.23 L 9.52,18.21 L 9.54,18.19 L 9.59,18.23 L 9.59,18.28 L 9.61,18.30 L 9.61,18.35 L 9.63,18.38 L 9.63,18.40 L 9.66,18.42 L 9.66,18.45 L 9.68,18.47 L 9.68,18.49 L 9.70,18.52 L 9.70,18.54 L 9.75,18.59 L 9.75,18.61 L 9.80,18.66 L 9.80,18.68 L 9.77,18.70 L 9.73,18.66 L 9.77,18.70 L 9.80,18.68 L 9.84,18.73 L 9.84,18.75 L 10.15,19.05 L 10.17,19.05 L 10.24,19.12 L 10.27,19.12 L 10.31,19.17 L 10.34,19.17 L 10.36,19.20 L 10.38,19.20 L 10.41,19.22 L 10.43,19.22 L 10.45,19.24 L 10.48,19.24 L 10.50,19.27 L 10.52,19.27 L 10.55,19.29 L 10.57,19.29 L 10.59,19.31 L 10.57,19.34 L 10.55,19.34 L 10.52,19.36 L 10.55,19.34 L 10.57,19.34 L 10.59,19.31 L 10.64,19.31 L 10.66,19.34 L 10.71,19.34 L 10.73,19.36 L 10.80,19.36 L 10.83,19.38 L 10.92,19.38 L 10.95,19.41 L 11.09,19.41 L 11.11,19.43 L 12.89,19.43 L 12.91,19.41 L 13.05,19.41 L 13.08,19.38 L 13.17,19.38 L 13.20,19.36 L 13.24,19.36 L 13.27,19.34 L 13.31,19.34 L 13.34,19.31 L 13.38,19.31 L 13.41,19.29 L 13.43,19.29 L 13.45,19.27 L 13.48,19.27 L 13.50,19.24 L 13.52,19.24 L 13.55,19.22 L 13.57,19.22 L 13.59,19.20 L 13.62,19.20 L 13.66,19.15 L 13.69,19.15 L 13.71,19.12 L 13.73,19.12 L 13.80,19.05 L 13.83,19.05 L 13.85,19.03 L 13.88,19.05 L 13.85,19.03 L 14.13,18.75 L 14.13,18.73 L 14.20,18.66 L 14.20,18.63 L 14.25,18.59 L 14.25,18.56 L 14.27,18.54 L 14.27,18.52 L 14.30,18.49 L 14.30,18.47 L 14.34,18.42 L 14.37,18.45 L 14.37,18.47 L 14.34,18.49 L 14.37,18.47 L 14.37,18.45 L 14.34,18.42 L 14.34,18.38 L 14.37,18.35 L 14.37,18.33 L 14.39,18.30 L 14.39,18.26 L 14.41,18.23 L 14.41,18.21 L 14.46,18.16 L 14.48,18.16 L 14.51,18.14 L 14.55,18.14 L 14.58,18.12 L 14.60,18.12 L 14.62,18.09 L 14.65,18.09 L 14.67,18.07 L 14.70,18.07 L 14.72,18.05 L 14.74,18.05 L 14.77,18.02 L 14.79,18.02 L 14.81,18.00 L 14.84,18.00 L 14.88,17.95 L 14.91,17.95 L 14.93,17.93 L 14.95,17.93 L 15.00,17.88 L 15.02,17.88 L 15.05,17.91 L 14.98,17.98 L 15.05,17.91 L 15.02,17.88 L 15.09,17.81 L 15.12,17.81 L 15.23,17.70 L 15.26,17.70 L 15.28,17.72 L 15.26,17.70 L 15.26,17.67 L 15.28,17.65 L 15.30,17.65 L 15.35,17.60 L 15.38,17.62 L 15.35,17.60 L 15.38,17.58 L 15.38,17.55 L 15.52,17.41 L 15.54,17.44 L 15.52,17.41 L 15.52,17.39 L 15.56,17.34 L 15.56,17.32 L 15.61,17.27 L 15.61,17.25 L 15.66,17.20 L 15.66,17.18 L 15.68,17.16 L 15.68,17.13 L 15.73,17.09 L 15.73,17.06 L 15.75,17.04 L 15.75,17.02 L 15.77,16.99 L 15.77,16.97 L 15.80,16.95 L 15.80,16.92 L 15.82,16.90 L 15.82,16.85 L 15.84,16.83 L 15.84,16.80 L 15.87,16.78 L 15.87,16.73 L 15.89,16.71 L 15.89,16.66 L 15.91,16.64 L 15.91,16.57 L 15.94,16.55 L 15.94,16.48 L 15.96,16.45 L 15.96,16.34 L 15.98,16.31 L 15.98,15.70 L 15.96,15.68 L 15.96,15.59 L 15.94,15.56 L 15.94,15.49 L 15.91,15.47 L 15.91,15.40 L 15.89,15.38 L 15.89,15.09 L 15.91,15.07 L 15.91,14.84 L 15.94,14.81 L 15.94,14.55 L 15.96,14.53 L 15.96,14.27 L 15.98,14.25 L 15.98,14.02 L 16.01,13.99 L 16.01,13.73 L 16.03,13.71 L 16.03,13.48 L 16.05,13.45 L 16.05,13.22 L 16.08,13.20 L 16.08,12.91 L 16.10,12.89 L 16.10,12.68 L 16.12,12.66 L 16.12,12.40 L 16.15,12.38 L 16.15,12.14 L 16.17,12.12 L 16.17,11.88 L 16.20,11.86 L 16.20,11.62 L 16.22,11.60 L 16.22,11.37 L 16.24,11.34 L 16.24,11.11 L 16.27,11.09 L 16.27,10.92 L 16.29,10.90 L 16.34,10.95 L 16.31,10.97 L 16.34,10.99 L 16.31,11.02 L 16.34,10.99 L 16.31,10.97 L 16.34,10.95 L 16.36,10.95 L 16.43,11.02 L 16.45,11.02 L 16.50,11.06 L 16.52,11.06 L 16.57,11.11 L 16.59,11.11 L 16.64,11.16 L 16.66,11.16 L 16.69,11.18 L 16.71,11.18 L 16.73,11.20 L 16.76,11.20 L 16.78,11.23 L 16.80,11.23 L 16.83,11.25 L 16.85,11.25 L 16.88,11.27 L 16.92,11.27 L 16.95,11.30 L 16.97,11.30 L 16.99,11.32 L 17.04,11.32 L 17.06,11.34 L 17.11,11.34 L 17.13,11.37 L 17.18,11.37 L 17.20,11.39 L 17.27,11.39 L 17.30,11.41 L 17.37,11.41 L 17.39,11.44 L 17.51,11.44 L 17.53,11.46 L 17.93,11.46 L 17.95,11.48 L 17.98,11.48 L 18.00,11.46 L 18.23,11.46 L 18.26,11.44 L 18.38,11.44 L 18.40,11.41 L 18.47,11.41 L 18.49,11.39 L 18.54,11.39 L 18.56,11.37 L 18.63,11.37 L 18.66,11.34 L 18.68,11.34 L 18.70,11.32 L 18.75,11.32 L 18.77,11.30 L 18.80,11.30 L 18.82,11.27 L 18.84,11.27 L 18.87,11.25 L 18.89,11.25 L 18.91,11.23 L 18.94,11.23 L 18.98,11.18 L 19.01,11.18 L 19.03,11.16 L 19.05,11.16 L 19.10,11.11 L 19.12,11.11 L 19.17,11.06 L 19.20,11.06 L 19.27,10.99 L 19.29,10.99 L 19.36,10.92 L 19.38,10.92 L 19.41,10.95 L 19.38,10.92 L 19.50,10.80 L 19.52,10.80 L 19.55,10.78 L 19.57,10.80 L 19.59,10.78 L 19.57,10.76 L 19.76,10.57 L 19.78,10.59 L 19.80,10.59 L 19.78,10.59 L 19.76,10.57 L 19.78,10.55 L 19.78,10.52 L 19.88,10.43 L 19.90,10.45 L 19.88,10.43 L 19.88,10.41 L 19.92,10.36 L 19.92,10.34 L 19.95,10.31 L 19.95,10.27 L 19.97,10.24 L 19.97,10.05 L 19.95,10.03 L 19.95,9.98 L 19.92,9.96 L 19.92,9.94 L 19.90,9.91 L 19.90,9.89 L 19.88,9.87 L 19.88,9.84 L 19.76,9.73 L 19.73,9.73 L 19.62,9.61 L 19.59,9.61 L 19.52,9.54 L 19.50,9.54 L 19.45,9.49 L 19.43,9.49 L 19.36,9.42 L 19.38,9.40 L 19.36,9.42 L 19.34,9.42 L 19.31,9.40 L 19.29,9.40 L 19.24,9.35 L 19.22,9.35 L 19.20,9.33 L 19.17,9.33 L 19.15,9.30 L 19.12,9.30 L 19.08,9.26 L 19.05,9.26 L 19.03,9.23 L 19.05,9.21 L 19.03,9.23 L 18.98,9.23 L 18.96,9.21 L 18.94,9.21 L 18.91,9.19 L 18.89,9.19 L 18.87,9.16 L 18.82,9.16 L 18.80,9.14 L 18.75,9.14 L 18.73,9.12 L 18.68,9.12 L 18.66,9.09 L 18.59,9.09 L 18.56,9.07 L 18.49,9.07 L 18.47,9.05 L 18.35,9.05 L 18.33,9.02 L 18.19,9.02 L 18.16,9.00 L 17.67,9.00 L 17.65,8.98 L 17.67,8.95 L 17.67,8.93 L 17.74,8.86 L 17.77,8.88 L 17.79,8.86 L 17.77,8.88 L 17.74,8.86 L 17.74,8.84 L 17.79,8.79 L 17.79,8.77 L 17.84,8.72 L 17.86,8.74 L 17.88,8.72 L 17.86,8.74 L 17.84,8.72 L 17.84,8.70 L 17.86,8.67 L 17.86,8.65 L 17.91,8.60 L 17.91,8.58 L 17.93,8.55 L 17.93,8.53 L 17.95,8.51 L 17.95,8.48 L 17.98,8.46 L 17.98,8.44 L 18.00,8.41 L 18.00,8.39 L 18.02,8.37 L 18.02,8.34 L 18.05,8.32 L 18.05,8.30 L 18.07,8.27 L 18.07,8.23 L 18.09,8.20 L 18.09,8.18 L 18.12,8.16 L 18.12,8.11 L 18.14,8.09 L 18.14,8.04 L 18.16,8.02 L 18.16,7.97 L 18.19,7.95 L 18.19,7.90 L 18.21,7.88 L 18.21,7.80 L 18.23,7.78 L 18.23,7.71 L 18.26,7.69 L 18.26,7.62 L 18.28,7.59 L 18.28,7.50 L 18.30,7.48 L 18.30,7.34 L 18.33,7.31 L 18.33,6.98 L 18.35,6.96 L 18.35,6.77 L 18.33,6.75 L 18.33,6.49 L 18.30,6.47 L 18.30,6.33 L 18.28,6.30 L 18.28,6.21 L 18.26,6.19 L 18.26,6.14 L 18.23,6.12 L 18.23,6.05 L 18.21,6.02 L 18.21,5.95 L 18.19,5.93 L 18.19,5.88 L 18.16,5.86 L 18.16,5.81 L 18.14,5.79 L 18.14,5.74 L 18.12,5.72 L 18.12,5.70 L 18.09,5.67 L 18.09,5.62 L 18.07,5.60 L 18.07,5.58 L 18.05,5.55 L 18.05,5.53 L 18.02,5.51 L 18.02,5.48 L 18.00,5.46 L 18.00,5.41 L 17.95,5.37 L 17.95,5.34 L 17.93,5.32 L 17.93,5.30 L 17.91,5.27 L 17.91,5.25 L 17.86,5.20 L 17.86,5.18 L 17.84,5.16 L 17.84,5.13 L 17.79,5.09 L 17.79,5.06 L 17.74,5.02 L 17.74,4.99 L 17.67,4.92 L 17.67,4.90 L 17.58,4.80 L 17.58,4.78 L 17.37,4.57 L 17.34,4.57 L 17.27,4.50 L 17.25,4.50 L 17.23,4.48 L 17.20,4.48 L 17.18,4.45 L 17.20,4.43 L 17.23,4.43 L 17.20,4.43 Z",
    fill: "currentColor"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M 16.78,4.41 L 16.80,4.41 Z",
    fill: "currentColor"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M 7.20,4.41 L 7.22,4.41 Z",
    fill: "currentColor"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M 17.04,4.38 L 17.11,4.38 Z",
    fill: "currentColor"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M 16.95,4.38 L 16.97,4.38 Z",
    fill: "currentColor"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M 16.85,4.38 L 16.90,4.38 Z",
    fill: "currentColor"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M 6.91,4.38 L 7.15,4.38 Z",
    fill: "currentColor"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M 13.27,0.82 Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCowface);
export default __webpack_public_path__ + "static/media/Cowface.f5fc7110e5144ebf2ada6bcf3488bfa2.svg";
export { ForwardRef as ReactComponent };